<div class="loginFooter">
  <div class="loginFooter__links">
    <a
      *ngIf="!checkOutWarmState; else logOutShopAgain"
      aria-label="Forgot Login Modal"
      href="javascript:void(0)"
      (click)="displayNextView(loginFooterData?.forgotLoginViewName)"
    >
      {{ loginFooterData?.forgotLoginText }}
      <span class="sr-only">
        Navigate to, {{ loginFooterData?.forgotLoginText }} Modal
      </span>
    </a>
    <div
      [ngClass]="{ 'loginFooter__divider--warm-state': checkOutWarmState }"
      class="loginFooter__divider"
    >
      &#124;
    </div>
    <a
      [ngClass]="{
        'loginFooter--forgot-password-warm-state': checkOutWarmState
      }"
      aria-label="Forgot Password Modal"
      href="javascript:void(0)"
      (click)="displayNextView(loginFooterData?.forgotPasswordViewName)"
    >
      {{ loginFooterData?.forgotPasswordText }}
      <span class="sr-only">
        Navigate to, {{ loginFooterData?.forgotPasswordText }} Modal
      </span>
    </a>
    <ng-template #logOutShopAgain>
      <a
        [ngClass]="{ 'loginFooter--logout-warm-state': checkOutWarmState }"
        [attr.aria-label]="loginFooterData.logOutAndShopAgainText"
        href="javascript:void(0)"
        (click)="logOutAndShopAgain()"
      >
        {{ loginFooterData.logOutAndShopAgainText }}
        <span class="sr-only">
          Navigate to, {{ loginFooterData.logOutAndShopAgainText }}
        </span>
      </a>
    </ng-template>
  </div>
  <div [ngClass]="setCustomClass()" class="joinSkyMilesDiv">
    <idp-button
      [label]="label"
      [size]="'full-width'"
      (notify)="action()"
      [type]="'secondary'"
      [customClass]="setCustomClass()"
    ></idp-button>
  </div>
</div>
